import { environment } from 'src/environments/environment';

export class AuthURLConfig {
  static get getApiKeybyAuthToken(): string {
    return `${environment.tileswsUrl}/CDAuth/GetApiKeyByAuthToken`;
  }

  static get getJwtToken(): string {
    const jwtHost = new URL(environment.ssoBaseUrl).origin;
    return `${jwtHost}/identity/v2/token`;
  }
  static get validateJwtToken(): string {
    return `${environment.tileswsUrl}/CDAuth/ValidateJWTToken`;
  }
}
